module.exports = __webpack_public_path__ + "img/graphic-4.89193d8f.png";